module.exports = __webpack_public_path__ + "static/media/flightLoader.59d6174b.gif";